export const RULES = {
  DATE: [{ required: true, message: 'This field is required' }],
};
